import { instance } from "./api";

// import api from "./api";


export async function getPlantReport(payloads) {
    const { maxDate, minDate } = payloads;
    const response = await instance.get(`admin/plantExcelReport?minDate=${minDate}&maxDate=${maxDate}`);
    return response.data;
}

export async function getLocationReport(payloads) {
    const { maxDate, minDate } = payloads;
    const response = await instance.get(`admin/locationExcelReport?minDate=${minDate}&maxDate=${maxDate}`);
    return response.data;
}

export async function getPlottingReport(payloads) {
    const { maxDate, minDate, location } = payloads;
    const response = await instance.get(`admin/plotExcelReport?minDate=${minDate}&maxDate=${maxDate}&location=${location}`);
    return response.data;
}

export async function getPlantationReport(payloads) {
    const { maxDate, minDate, location, plot, plant } = payloads;
    const response = await instance.get(`admin/plantationExcelReport?minDate=${minDate}&maxDate=${maxDate}&location=${location}&plot=${plot}&plant=${plant}`);
    return response.data;
}

export async function getMonitoringReport(payloads) {
    const { maxDate, minDate, location, plot, plant } = payloads;
    const response = await instance.get(`admin/monitoringExcelReport?minDate=${minDate}&maxDate=${maxDate}&location=${location}&plot=${plot}&plant=${plant}`);
    return response.data;
}



